import { render } from "./PrivacyPolicy.vue?vue&type=template&id=3e89e4be&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=3e89e4be&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e89e4be"]])

export default __exports__